import { GoogleGenerativeAI } from "@google/generative-ai"
import { createStore, StoreCore } from "@priolo/jon"
import { extractFunctionAndDescription } from "./utils"
import { pivotGridSelectPrompt } from "./pivotGridSelectPrompt"


// used when dialog closed
let resolveClose = null

const setup = {

	state: {
		key: <string>null,
		agent: <GoogleGenerativeAI>null,
		dialogIsOpen: false,

	},

	getters: {
	},

	actions: {
		open: async (_: void, store?: AgentStore) => {
			store.setDialogIsOpen(true)
		},
		save: ({ key, remember }: { key: string, remember: boolean }, store?: AgentStore) => {
			store.setKey(key)
			store.state.agent = new GoogleGenerativeAI(key)
		},
		run: async (prompt: string, store?: AgentStore) => {
			if (!store.state.key || !store.state.agent) {
				store.open()
				return
			}
			if (!prompt || prompt.trim().length == 0) return

			const model = store.state.agent.getGenerativeModel({
				//model: "gemini-1.5-flash",
				model: "gemini-2.0-flash",
				generationConfig: { temperature: 0 },
			})

			const chat = model.startChat()
			const { system, structureData, instructions, examples } = pivotGridSelectPrompt
			const requestTxt = `${system} ${structureData} ${instructions} ${examples}. Answer the following question with the javascript search function and description: ${prompt}`
			const result = await chat.sendMessage(requestTxt)
			const responseTxt = result.response.text()

			console.log("-------------------------")
			console.log(requestTxt)
			console.log("-------------------------")

			const { functionJs, description } = extractFunctionAndDescription(responseTxt)
			
			console.log(functionJs)
			console.log("--------------------")
			console.log(description)
			console.log("--------------------")

			//const select:(item:any, array:any[]) => boolean = new Function(`return ${def}`)()
			const select: (array: any[]) => number[] = new Function(`return ${functionJs}`)()
			return { fn: select, description }
		}
	},

	mutators: {
		setDialogIsOpen: (dialogIsOpen: boolean) => ({ dialogIsOpen }),
		setKey: (key: string) => ({ key }),
	},
}

export type AgentState = typeof setup.state
export type AgentGetters = typeof setup.getters
export type AgentActions = typeof setup.actions
export type AgentMutators = typeof setup.mutators
export interface AgentStore extends StoreCore<AgentState>, AgentGetters, AgentActions, AgentMutators {
	state: AgentState
}

const agentSo = createStore(setup) as AgentStore

export default agentSo
